//Generated File 
export default class DocumentFileStatus{
	static readonly ApprovalPending = `ApprovalPending`;
	static readonly ApprovalRejected = `ApprovalRejected`;
	static readonly ApprovalReturned = `ApprovalReturned`;
	static readonly Cancelled = `Cancelled`;
	static readonly Draft = `Draft`;
	static readonly Stable = `Stable`;
}
